import Bootstrap from '$js/bootstrap';
import App from '$js/App.svelte';
import { mount } from 'svelte';

new Bootstrap();

// Scroll to top on page load
window.scrollTo({ top: 0 });

// Set CSS variable for 1vh
document.documentElement.style.setProperty('--vh', `${String(window.innerHeight * 0.01)}px`);

// Mount the Svelte app
mount(App, {
  target: document.getElementById('app')!,
});
